<template>
  <div class="h-full">
    <HomeMobile />
  </div>
</template>

<script>
import HomeMobile from '../components/mobile/pages/Home.vue'

export default {
  name: 'home',
  components: { HomeMobile },
  data() {
    return {
      eventsIds: [],
      activeTab: 'home',
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {},
  methods: {},
}
</script>
